import React from "react"
import { Toaster } from "react-hot-toast"
import "./src/styles/global.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export const wrapPageElement = ({ element, props }) => (
  <main>
    {element}
    <Toaster />
  </main>
)
